import { Component, OnInit, Input } from '@angular/core';
import { ElogioService } from 'src/app/service/elogio/elogio.service';
import { DesmarcarOutrasOpcoesService } from 'src/app/service/util/desmarcar-outras-opcoes.service';
import { AuthService } from 'src/app/service/autenticacao/auth.service';

@Component({
  selector: 'cartorio-extrajudicial-elogio',
  templateUrl: './cartorio-extrajudicial-elogio.component.html',
  styleUrls: ['./cartorio-extrajudicial-elogio.component.css']
})
export class CartorioExtrajudicialElogioComponent implements OnInit {

  @Input() visualizacao: boolean;
  listaClassificacaoComponente;
  charNum = 5000;
  charNumNomes = 1000;

  constructor(public service: ElogioService,
    public desmarcarOutrasOpcoesService: DesmarcarOutrasOpcoesService,
    public authService: AuthService) { }

  ngOnInit() {
    this.preencherListaClassificacao()
  }

  preencherListaClassificacao() {
    this.listaClassificacaoComponente = this.service.elogio.value.listaClassificacaoCompleta
      .filter(item => item.assunto.id === this.service.elogio.value.assunto.id);
  }

  checkClassificacao(item) {
    this.desmarcarOutrasOpcoesService.desmarcarTodasOpcoesExcetoItem(this.listaClassificacaoComponente, item);
    this.atribuirListaClassificacao();
  }

  atribuirListaClassificacao() {
    this.service.elogio.controls.listaClassificacao.setValue(this.listaClassificacaoComponente.filter(lcc => lcc.selecionado));
  }

  contemErro(str) {
    return this.service.elogio.controls[str].touched &&
      this.service.elogio.controls[str].errors != null;
  }

  countChar(valor, max) {
    this.charNum = max - valor.length;
  }

  countCharNome(valor, max) {
    this.charNumNomes = max - valor.length;
  }

}
